<template>
  <div class="xh-esg-page">
    <el-row class="xh-esg-header">
      <el-col :span="24">
        <div class="xh-esg-header-banner"></div>
      </el-col>
    </el-row>
    <el-row class="xh-esg-content">
      <el-row>
        <el-col class="xh-esg-right" :span="24">
          <el-tabs v-model="activeName">
            <el-tab-pane :label="item.label" :name="String(index)" v-for="(item,index) in infoMenuList" :key="item.code">
             <!-- <tab-1 v-show="index==0"></tab-1>
             <tab-2 v-show="index==1"></tab-2>
             <tab-3 v-show="index==2"></tab-3> -->
              <component :is="['tab-1', 'tab-2', 'tab-3'][index]"></component>

            </el-tab-pane>
            <!-- <el-tab-pane label="走进ESG" name="0">
              <tab-1></tab-1>
            </el-tab-pane>
            <el-tab-pane label="新华CN-ESG" name="1">
              <tab-2></tab-2>
            </el-tab-pane>
            <el-tab-pane label="ESG培训" name="2">
              <tab-3></tab-3>
            </el-tab-pane> -->
          </el-tabs>
          <!-- <List :classifyCode="classifyCode"></List> -->
        </el-col>
      </el-row>
      <!-- <el-row>ddd </el-row> -->
    </el-row>
  </div>
</template>
<script>
//import { mapActions } from "vuex";
//import List from "./components/List";
import { mapActions } from "vuex";
import tab1 from './components/tab1.vue'
import tab2 from './components/tab2.vue'
import tab3 from './components/tab3.vue'
export default {
  data() {
    let { query: {index}} = this.$route;
    index = index || "0";
    return {
      infoMenuList:null,
      activeName: index,
    };
  },
  components: {
    tab1,
    tab2,
    tab3
   /*  List, */
  },
  computed: {

  },//
  mounted() {
    this.getTabMenuList().then((data) => {
      console.log(data)
      this.infoMenuList = data;
    });
  },
  methods: {
    ...mapActions("collegeInfo/index", {
      getTabMenuList: "GET_TAB_MENU_LIST",
    }),
    /* leftSelect(index) {
      let currentMenu = this.leftMenus[index];
      this.classifyCode = currentMenu.code;
    }, */
/*     handleClick(tab, event) {
        console.log(tab, event);
        let code=tab.name;
        console.log(tab.name)
          this.getInfoList(code).then((data)=>{
          console.log(data)
          this.infoList=data.data
        })
        
        
      }  */   
  },
};
</script>
<style lang="scss" scoped>
/* /deep/ .el-tabs__nav-wrap::after{
  height: 0;
} */

#app{
  .page{
    /deep/ .content{
      background-color: #fff;
      margin-bottom: 100px;
      
    }
    
  }
}
  /deep/ .el-tabs__item{
    color: var(--font_01);
  }

.Black {
    .el-tabs /deep/ {
      .el-tabs__nav-wrap::after{
      background-color: #162D48;
    }
  }
}
/deep/ .el-tabs__item.is-active{
font-weight: bold;
color: var(--font_01);
}
/deep/ .el-tabs__active-bar{
  background-color: var(--font_05);
}
/deep/ .el-tabs__item:hover {
    color: var(--font_05);
    
}
.xh-esg-page {
  .xh-esg-header {
    .xh-esg-header-banner {
      height: 220px;
      background: url("../../assets/white_theme/esg-college.png")
        no-repeat;
      background-position: center;
      background-size: cover;
    }
  }
  .xh-esg-content {
    /* max-width: 1020px;
    margin: auto; */
    margin-top: 30px;
  }
  .xh-esg-left {
    .xh-esg-left-block {
      padding: 0px 25px;
      background-color: #ffffff;
      margin-bottom: 15px;
    }
  }
  .xh-esg-right {
    /deep/ .el-tabs__header{
      width: 1100px;
      margin: 0 auto;
    }
    /* .tab1{
      width: 100%;
      //height: 438px;
      margin: 0 auto;
      .title{
        display: flex;
        margin-top: 10px;
        margin-bottom: 20px;
        padding-left: 2px;
        font-weight: 500;
        .icon{
          position: relative;
          margin-right: 10px;
          margin-top: 4px;
          .before{
            position: absolute;
            top: 2px;
            left: -2px;
            width: 10px;
            height: 10px;
            background-color: #008BCE;
          }
          .after{
            display: block;
            width: 10px;
            height: 10px;
            background-color: #008BCE;
            opacity: 0.19;
          }

        }
      }
      .desc{
        line-height: 22px;
        
      }
      .img1-1{
        width: 840px;
        height: 185px;
        margin: 0 auto;
        background: url('../../assets/white_theme/esg-college-tab1-1.png') no-repeat;
        background-position: center;
        background-size: cover;
        margin-bottom: 60px;
      }
      .img1-2{
        width: 604px;
        height: 581px;
        margin: 0 auto;
        background: url('../../assets/white_theme/esg-college-tab1-2.png') no-repeat;
        background-position: center;
        background-size: cover;
      }
      .img1-3{
        width: 604px;
        height: 797px;
        margin: 0 auto;
        background: url('../../assets/white_theme/esg-college-tab1-3.png') no-repeat;
        background-position: center;
        background-size: cover;
        margin-bottom: 50px;
      }
    } */
    /* .tab2{
      width: 100%;
     
      margin: 0 auto;
      .title{
          display: flex;
          margin-top: 10px;
          margin-bottom: 20px;
          padding-left: 2px;
          font-weight: 500;
        .icon{
          position: relative;
          margin-right: 10px;
          margin-top: 4px;
          .before{
            position: absolute;
            top: 2px;
            left: -2px;
            width: 10px;
            height: 10px;
            background-color: #008BCE;
          }
          .after{
            display: block;
            width: 10px;
            height: 10px;
            background-color: #008BCE;
            opacity: 0.19;
          }

        }
      }
      .titleContainer{
        display: flex;
        justify-content: space-between;
        .title{
          display: flex;
          margin-top: 10px;
          margin-bottom: 20px;
          padding-left: 2px;
          font-weight: 500;
          .icon{
            position: relative;
            margin-right: 10px;
            margin-top: 4px;
            .before{
              position: absolute;
              top: 2px;
              left: -2px;
              width: 10px;
              height: 10px;
              background-color: #008BCE;
            }
            .after{
              display: block;
              width: 10px;
              height: 10px;
              background-color: #008BCE;
              opacity: 0.19;
            }

          }
        }
      }
      .item2Container{
        display: flex;
        justify-content: space-between;
        padding-left: 40px;
        margin-bottom: 100px;
        margin-top: 60px;
        .item2Img1{
          width: 572px;
          height: 155px;
          background: url('../../assets/white_theme/esg-college-tab2-2-1.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .item2Img2{
          width: 572px;
          height: 155px;
          background: url('../../assets/white_theme/esg-college-tab2-2-2.png') no-repeat;
          background-position: center;
          background-size: cover;

        }
        .item2Right{
          width: 287px;
          height: 280px;
          margin-top: 30px;
          margin-right: 60px;
          background: url('../../assets/white_theme/esg-college-tab2-2-3.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
      }
      .item3Container{
        display: flex;
        justify-content: space-between;
        .item3Left{
          width: 660px;
          
          
        }
        .item3Right{
          width: 300px;
          height: 170px;
          background: url('../../assets/white_theme/esg-college-tab2-3.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
      }
      .item4Container{
        display: flex;
        justify-content: space-between;
        margin-top: 80px;
        .item4Left{
          width: 300px;
          height: 170px;
          background: url('../../assets/white_theme/esg-college-tab2-4.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .item4Right{
          width: 660px;
          
          
        }
      }
      .desc{
        line-height: 22px;
      }
      .img1-1{
        width: 840px;
        height: 185px;
        margin: 0 auto;
        background: url('../../assets/white_theme/esg-college-tab1-1.png') no-repeat;
        background-position: center;
        background-size: cover;
      }
      .item1Container{
        display: flex;
        justify-content: space-between;
        margin-bottom: 80px;
        .desc{
          width: 582px;
          height: 210px;
          .row{
            margin-bottom: 10px;
          }

        }
        .img2-1{
          width: 371px;
          height: 209px;
          background: url('../../assets/white_theme/esg-college-tab2-1.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
      }

    } */
    
  }
}
</style>
